import { render, staticRenderFns } from "./ShowHideEffect.vue?vue&type=template&id=19c84a52&"
import script from "./ShowHideEffect.vue?vue&type=script&lang=js&"
export * from "./ShowHideEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports